export default function () {
  return {
    receiverLicense: null,
    pickUpDate: "",
    dropOffDate: "",
    isDropOff: false,
    packageModel: "packages",
    packageTiming: "now",
  };
}
